import { Option } from '@sapphire/result';
import { SurveyQualification } from '@ps/survey-utils';
import { SurveyCreationChildAudienceState } from '../../survey-creation-state.model';

// Present before and gone now — a fresh upload not yet synced into the qualifications, or a
// failed one that never was, keeps its state.
export function hasRemovedUploadedLocation(
  child: SurveyCreationChildAudienceState,
  nextQualifications: readonly SurveyQualification[],
): boolean {
  return Option.from(child.locationFileUpload.qualificationCode)
    .filter((code) => holds(child.qualifications.value, code))
    .filter((code) => !holds(nextQualifications, code))
    .isSome();
}

function holds(
  qualifications: readonly SurveyQualification[],
  qualificationCode: number,
): boolean {
  return qualifications.some(
    (qualification) => qualification.qualificationCode === qualificationCode,
  );
}
